import { __decorate } from "tslib";
import Modal from '@/components/Modal.vue';
import DatePicker from '@/components/DatePicker.vue';
import MoneyField from '@/components/MoneyField.vue';
import Money from '@/components/Money.vue';
import CustomSwitch from '@/components/CustomSwitch.vue';
import { mapActions, mapGetters } from 'vuex';
import ModalMixin from '@/mixins/modal-mixin';
import { Component, Prop, Watch } from "vue-property-decorator";
let supplyModal = class supplyModal extends ModalMixin {
    /*Props*/
    id;
    errors;
    data;
    /*Data*/
    title = 'Supply';
    hideForm = false;
    supplierDefaults = {
        address: {},
        contacts: {},
        enableAddress: true
    };
    localData = {
        productId: 0,
        initialQuantity: 0,
        retailPrice: 0,
        price: 0,
        quantity: 0,
        supplyOn: '',
        expireOn: '',
        supplierId: '',
        current: false
    };
    /*Computed*/
    findSuppliersInStore;
    getProductById;
    create;
    patch;
    get product() {
        return this.getProductById(this.data.productId);
    }
    get suppliers() {
        return this.findSuppliersInStore().data.map((item) => {
            return { value: item._id, text: item.label };
        });
    }
    get proceduresPerBatch() {
        let proceduresPerBatch = (this.localData.initialQuantity || 0) / this.product.perServing;
        if (!proceduresPerBatch)
            proceduresPerBatch = 0;
        return proceduresPerBatch;
    }
    get selfPrice() {
        let selfPrice = (this.localData.price || 0) / this.proceduresPerBatch;
        if (!selfPrice)
            selfPrice = 0;
        return selfPrice;
    }
    get singleProcedureProfit() {
        return (this.localData.retailPrice || 0) - this.selfPrice;
    }
    get totalProfit() {
        let totalProfit = this.proceduresPerBatch * this.singleProcedureProfit;
        if (!totalProfit)
            totalProfit = 0;
        return totalProfit;
    }
    get totalSold() {
        let totalSold = (this.localData.retailPrice || 0) * this.proceduresPerBatch;
        if (!totalSold)
            totalSold = 0;
        return totalSold;
    }
    /*Methods*/
    saveAction() {
        let promise, successMessage;
        if (this.data._id) {
            promise = this.patch([this.data._id, this.localData]);
            successMessage = 'Supply has been saved';
        }
        else {
            promise = this.create(this.localData);
            successMessage = 'Supply has been created';
        }
        promise.then(() => {
            this.$root.$emit('bv::hide::modal', this.id);
            this.$toasted.global.success({
                message: successMessage
            });
        }).catch((e) => {
            this.$toasted.global.error({
                message: e.message
            });
        });
    }
    shown() {
    }
    close() {
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    openSupplierForm() {
        let details = {
            data: this.supplierDefaults,
            _id: 'temp'
        };
        const { Supplier } = this.$FeathersVuex;
        new Supplier(details);
        this.openModal({ id: 'supplierFormModal' });
    }
    onDataChanged() {
        this.localData = this.data;
    }
};
__decorate([
    Prop({ type: String })
], supplyModal.prototype, "id", void 0);
__decorate([
    Prop({ type: Object })
], supplyModal.prototype, "errors", void 0);
__decorate([
    Prop({ type: Object })
], supplyModal.prototype, "data", void 0);
__decorate([
    Watch('data')
], supplyModal.prototype, "onDataChanged", null);
supplyModal = __decorate([
    Component({
        components: {
            Modal,
            Money,
            MoneyField,
            CustomSwitch,
            DatePicker
        },
        computed: {
            ...mapGetters('suppliers', { findSuppliersInStore: 'find' }),
            ...mapGetters('products', { getProductById: 'get' }),
        },
        methods: {
            ...mapActions('supplies', ['create', 'patch']),
        }
    })
], supplyModal);
export default supplyModal;
